import type { InjectionKey, Ref } from 'vue'

type ExperiencesSearch = {
  searchTerm: Ref<string | undefined>
  hasTags: Ref<boolean>
}

const key: InjectionKey<ExperiencesSearch> = Symbol('experiences-search')

// Lets a page show the experiences search itself; the grid shows it on its own bar when there are tags
export const provideExperiencesSearch = (): ExperiencesSearch => {
  const search = { searchTerm: ref<string>(), hasTags: ref(false) }
  provide(key, search)
  return search
}

export const injectExperiencesSearch = (): ExperiencesSearch | null => inject(key, null)
